<template>
  <div>
    <vx-card>
      <div class="vx-row">
        <div class="vx-col md:w-1/3 w-full">
          <h6 class="mb-2">Empresa</h6>
          <vs-input class="w-full" disabled :value="partsRequirement.fantasia || partsRequirement.empresa"></vs-input>
        </div>
        <div class="vx-col md:w-1/3 w-full">
          <h6 class="mb-2">CPF/CNPJ</h6>
          <vs-input class="w-full" disabled :value="partsRequirement.cpfCnpj"></vs-input>
        </div>
        <div class="vx-col md:w-1/3 w-full">
          <h6 class="mb-2">Email</h6>
          <vs-input class="w-full" disabled :value="partsRequirement.email"></vs-input>
        </div>
      </div>
      <br>
      <div class="vx-row">
        <div class="vx-col md:w-1/3 w-full">
          <h6 class="mb-2">Contato</h6>
          <vs-input class="w-full" disabled :value="partsRequirement.contato"></vs-input>
        </div>
        <div class="vx-col md:w-1/3 w-full">
          <h6 class="mb-2">Telefone</h6>
          <vs-input class="w-full" disabled :value="partsRequirement.telefone"></vs-input>
        </div>
        <div class="vx-col md:w-1/3 w-full">
          <h6 class="mb-2 hyperlink" @click="redirectToWhatsapp()">Whatsapp</h6>
          <vs-input class="w-full" disabled :value="partsRequirement.whatsapp"></vs-input>
        </div>
      </div>
      <br>
      <h4 class="mb-5">Peças</h4>
      <div class="vx-row">
        <div :class="'vx-col w-full md:w-1/' + requirements.length" v-for="(requirement, index) in requirements" v-bind:key="index">
          <vx-card>
            <b>{{requirement.marca}}</b>
            <br>
            <div class="vx-row">
              <div class="vx-col md:w-1/2">
                <b>Peça</b>
              </div>
              <div class="vx-col md:w-1/2">
                <b>Modelo</b>
              </div>
            </div>
            <div class="vx-row" v-for="(part, index) in requirement.necessidades" v-bind:key="index">
              <div class="vx-col md:w-1/2">
                {{part.peca}}
              </div>
              <div class="vx-col md:w-1/2">
                {{part.modelo}}
              </div>
            </div>
          </vx-card>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import helpers from '@/helpers'
import axios from 'axios'
import { baseApiUrl } from "@/global"

export default {
  data() {
    return {
      idPartsRequirement: null,
      helpers: null,
      partsRequirement: [],
      requirements: [],
      lastBrand: null
    }
  },
  methods: {
    log(parts) {
      console.log(parts)
    },
    async loadPartsRequirement() {
      try {
        this.$vs.loading();
        const response = await axios.get(`${baseApiUrl}/partsRequirement/${this.idPartsRequirement}`);
        this.partsRequirement = response.data
        this.requirements = response.data.jsonNecessidades
      } catch (error) {
        this.$vs.notify({
          title: "Erro",
          text: "Não foi possivel carregar" + error,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    redirectToWhatsapp() {
      const baseUrl = 'https://wa.me/'
      let number = this.partsRequirement.whatsapp

      if (number.length == 8 || number.length == 9) {
        this.$vs.dialog({
          color: 'danger',
          title: `Número Inválido`,
          text: `O número ${number} é invalido ou não possui DDD.`,
          acceptText: "Fechar",
        })
        return
      }
      if (number.length == 10 || number.length == 11)
        number = `55${number}`

      if (number.length > 13)
        console.log('numero invalido')

      window.open(baseUrl + number, '_blank');
    }
  },
  async created() {
    this.idPartsRequirement = this.$route.params.idPartsRequirement
    await this.loadPartsRequirement()
  },
}

</script>

<style>

</style>
